import { RequestsList } from './RequestsList';

export default RequestsList;
